/* ============================================================
   BANYO ATELIER — Sonsuz kaydırma (infinite scroll)
   Koleksiyon ve arama sayfalarında pagination yerine
   sayfa sonuna gelince sonraki sayfayı otomatik yükler.
   ============================================================ */
(function () {
  'use strict';

  var state = null; // aktif tekil durum

  function teardown() {
    if (state && state.observer) state.observer.disconnect();
    if (state && state.sentinel && state.sentinel.parentNode) {
      state.sentinel.parentNode.removeChild(state.sentinel);
    }
    state = null;
  }

  function init() {
    var grid = document.getElementById('product-grid');
    var pag = document.querySelector('.pagination-wrapper');
    if (!grid || !pag) return;
    if (pag.getAttribute('data-gha-infinite') === '1') return; // zaten kurulu

    var currentPage = parseInt(pag.getAttribute('data-page') || '1', 10);
    var pageNums = [].slice.call(pag.querySelectorAll('.pagination__item'))
      .map(function (el) { return parseInt(el.textContent.trim(), 10); })
      .filter(function (n) { return !isNaN(n); });
    var maxPage = pageNums.length ? Math.max.apply(null, pageNums.concat([currentPage])) : currentPage;
    if (currentPage >= maxPage) return;

    pag.setAttribute('data-gha-infinite', '1');
    pag.style.display = 'none';

    // id="product-grid" DIŞTAKİ sarmalayıcı <div>; ürünler içteki <ul>'ye eklenmeli.
    // Aksi halde <li>'ler ızgaranın dışına düşer: madde işareti görünür, hizalama bozulur.
    var list = grid.querySelector('ul.product-grid') || grid.querySelector('ul.grid') || grid;

    var s = {
      grid: list, pag: pag, maxPage: maxPage,
      nextPage: currentPage + 1, loading: false, observer: null, sentinel: null
    };
    state = s;

    var sentinel = document.createElement('div');
    sentinel.className = 'gha-infinite-sentinel';
    sentinel.innerHTML = '<div class="gha-infinite-spinner"><span></span><span></span><span></span></div>';
    pag.parentNode.insertBefore(sentinel, pag);
    s.sentinel = sentinel;
    var spinner = sentinel.querySelector('.gha-infinite-spinner');
    spinner.style.visibility = 'hidden';

    function buildUrl(page) {
      var u = new URL(window.location.href);
      u.searchParams.set('page', page);
      return u.toString();
    }

    function loadNext() {
      if (s.loading || s.nextPage > s.maxPage) return;
      s.loading = true;
      spinner.style.visibility = 'visible';

      fetch(buildUrl(s.nextPage), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('product-grid');
          var items = newGrid ? newGrid.querySelectorAll('.grid__item') : [];
          if (!items.length) { finish(); return; }

          items.forEach(function (li) { s.grid.appendChild(document.importNode(li, true)); });
          s.nextPage++;
          s.loading = false;
          spinner.style.visibility = 'hidden';

          window.dispatchEvent(new Event('scroll')); // swatch/animasyon tetikle
          if (s.nextPage > s.maxPage) { finish(); return; }
          // İçerik hâlâ kısa ve sentinel görünürse zincirleme yükle
          requestAnimationFrame(check);
        })
        .catch(function () { s.loading = false; spinner.style.visibility = 'hidden'; });
    }

    function finish() {
      spinner.style.visibility = 'hidden';
      if (s.observer) s.observer.disconnect();
      window.removeEventListener('scroll', onScroll);
    }

    function isNear() {
      var r = sentinel.getBoundingClientRect();
      return r.top <= (window.innerHeight + 700);
    }
    function check() { if (isNear()) loadNext(); }
    function onScroll() { check(); }

    // IntersectionObserver + scroll fallback (ikisi birden — güvenli)
    if ('IntersectionObserver' in window) {
      s.observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadNext();
      }, { rootMargin: '700px 0px' });
      s.observer.observe(sentinel);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    // İlk kontrol (kısa sayfa / sentinel zaten görünür ise)
    requestAnimationFrame(check);

    // Debug
    window.__ghaLoadNext = loadNext;
  }

  function boot() {
    init();
    // Filtre/sıralama AJAX ile grid yenilenince yeniden kur
    var container = document.querySelector('#ProductGridContainer') || document.querySelector('main');
    if (container) {
      var mo = new MutationObserver(function () {
        var pag = document.querySelector('.pagination-wrapper');
        if (pag && pag.getAttribute('data-gha-infinite') !== '1') {
          teardown();
          init();
        }
      });
      mo.observe(container, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
